import { Dispatch, SetStateAction } from "react";

export const handleNextStep = (
  currentStep: number,
  setCurrentStep: Dispatch<SetStateAction<number>>,
  stepsLength: number
) =>
  currentStep < stepsLength &&
  setCurrentStep((previousStep) => previousStep + 1);

export const handlePreviousStep = (
  currentStep: number,
  setCurrentStep: Dispatch<SetStateAction<number>>
) => currentStep > 0 && setCurrentStep((previousStep) => previousStep - 1);
